import { Component, OnInit, Input, ViewContainerRef, ComponentFactoryResolver, ViewChild, OnChanges, SimpleChange, ElementRef, ComponentRef, OnDestroy, Inject } from '@angular/core';
import { AdBuildingComponent } from './ad-building/ad-building.component';
import { AdvertiseComponent } from './advertise/advertise.component';
import { ActivatedRoute } from '@angular/router';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdPropertiesComponent } from './ad-properties/ad-properties.component';
import { AdVehiclesComponent } from './ad-vehicles/ad-vehicles.component';
import { AdGroundComponent } from './ad-ground/ad-ground.component';
import { ViewService } from './view.service';
import { Subscription } from 'rxjs';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { RequestService } from 'src/app/shared/services/request.service';


declare var $: any;

@Component({
  selector: 'view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})

export class ViewComponent implements OnInit, OnChanges, OnDestroy {

  @Input() data : any = [];
  @Input() modalId : any = [];
  @ViewChild("container", { static:true, read: ViewContainerRef }) container:ViewContainerRef;

  modal : any = {};
  modalActive = null;

  id = null;
  private attrs:any = {};

  private elClasslist = null;
  private componentRef:ComponentRef<any>;

  loading = false;
  error = false;
  type:any;
  typeComponent:any = '';
 
  typeTitle = {
    ad : 'Anúncio',
    person : 'Perfil'
  }

  errorImageUrl = '';

  private callbackSubscribe:Subscription;

  private components = {
      'building'        : AdBuildingComponent,
      'allotment'       : AdBuildingComponent,
      'properties'      : AdPropertiesComponent,
      'ground'          : AdGroundComponent,
      'vehicles'        : AdVehiclesComponent,
      'advertise'       : AdvertiseComponent
  };

  constructor(
    private gs: GeneralService,
    private elRef:ElementRef,
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private srs: AdSearchService,
    private vs : ViewService,
    protected als : AppLoadingService,
    protected rs : RequestService
  ) { 
    


      this.callbackSubscribe = this.vs.callback$.subscribe((result) => {
        this.callbackComponent(result);
      });

      if(this.route.snapshot.paramMap.get('id'))
        this.id = this.route.snapshot.paramMap.get('id');

      if(this.route.snapshot.paramMap.get('type') || this.route?.snapshot?.routeConfig?.data?.type)
        this.type = this.route.snapshot.paramMap.get('type') || this.route?.snapshot?.routeConfig?.data?.type;

      this.elClasslist= this.elRef.nativeElement.classList;

      this.errorImageUrl = this.getErrorImageUrl();
  }


  ngOnInit() {
    this.srs.setFilterGroup(this.type);
    this.loadComponent(this.id);
  }

  ngOnDestroy(){
    this.callbackSubscribe.unsubscribe();
  }

  async ngOnChanges(changes: { [key: string]: SimpleChange }) {
    this.attrs = changes.data.currentValue;
//    this.gs.setTitle(this.id);

    if(changes.data?.currentValue['loadingAd']){
      this.elClasslist.remove('closing');
      this.elClasslist.add(...['loading','over','opening']);
      await this.loadComponent(changes.data.currentValue['loadingAd']);
    }
  }

  i = 0;

  async loadComponent(id){
    if(!id)
      return;
      
    await this.als.setLoaded(false, 'ViewComponent');

    this.id = id?.length == parseInt(id).toString().length && !isNaN(parseInt(id))? parseInt(id) : id;
    this.loading = true;

    this.data = this.srs.getHitByFriendly(this.id, this.type);

    if(this.data?.adId || this.data?.personId)
      this.gs.event('view',{id:(this.type=='ad'? this.data.adId : this.data.personId), type: this.type});
    
    if(!this.data?.level || this.data.level != 'view'){
      this.error = false;
      
      await this.srs.loadAd(this.id, {resultType:this.type})
        .then(item => {
          if(!item?.id) 
            this.error = true;
          else {
            this.data = this.srs.getHitByFriendly(this.id, this.type); 
            this.setDefault();
          }
        })
        .catch((er) => {console.log(er);  this.error = true; })
        .finally(() => {
          this.loading = false;
          this.als.setLoaded(true, 'ViewComponent');
        });
      return;
    } else {
      this.als.setLoaded(true, 'ViewComponent');
    }
    
    this.setDefault();
  }
  setDefault(){
    let type = '';
    
    switch(this.type){
      case 'person':
        this.gs.setTitle(this.data?.personName);
        this.typeComponent = 'advertise';
      break;
      case 'ad':
        this.gs.setTitle(this.data.title+ ' - '+this.data.owner.personName);
        this.typeComponent = this.srs.getAdType(parseInt(this.data['typeId']));
        
        this.data.units?.map(item=>{
          item.amountNum = parseInt(item.amount);
          if(isNaN(item.amountNum))
            item.amountNum = 0;

          item.amountOldNum = parseInt(item.amountOld);
          if(isNaN(item.amountOldNum))
            item.amountOldNum = 0;

          item.typeTitle = this.gs.getTags('unitType', false, item?.typeId);

          return item;
          
        });
      break;
    }
    
    this.elClasslist.remove('loading');
    this.elClasslist.add('loaded');
    this.loading = false;
console.log(this.typeComponent, this.type);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponent(this.typeComponent));

    this.container.clear();
    this.componentRef = this.container.createComponent(componentFactory);
    (<any>this.componentRef.instance).data = {...this.data,attrs: this.attrs, typeComponent: this.typeComponent, modalId: this.modalId};
    (<any>this.componentRef.instance).viewInstance = this;


  }

  callbackComponent(result){
    
    if(!result || this.data?.adId != result.data?.adId)
      return;


    switch(result?.action){
      case 'comission':
        this.modal = result?.data;
        setTimeout(() => {
          this.modalActive = result.action;
          $('[id="'+this.modalId+'"] #comissionModal').modal('show');
        }, 100);
      break;
      case 'report':
        this.modal = result?.data;
        setTimeout(() => {
          this.modalActive = result.action;
          $('[id="'+this.modalId+'"] #reportModal').modal('show');
        }, 100);
      break;
      case 'material':
        this.rs.materialRequest(result.data);
      break;
      case 'authorization':
        this.rs.setRequestAction(null, result.data);
      break;
    }
    if(result?.action)
      this.vs.setCallback(null);
    
  }

  getComponent(type){
    return this.components[type];
  }

  close(event:Event){
    this.elClasslist.remove('opening');
    this.elClasslist.add('closing');
    event.stopPropagation();
    this.componentRef.destroy();
  }

  getErrorImageUrl() {
    return this.gs.buildImagemUrl('icon-clear.png');
  }



}
